module.exports = __webpack_public_path__ + "img/HedaerWave.b4133680.png";